import Routes from "./pages/routes";
import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GoogleOAuthProvider } from "@react-oauth/google";

import "./App.css";
import { AppProvider } from "./services/app-context";
import ImageCropProvider from "./components/ImageCropper/provider/ImageCropProvider";
import { AdminUsersProvider } from "./pages/manageAdmin/context/AdminUsersContext";
import { ClientReferralProvider } from "./pages/clientReferrals/context/ClientReferralContext";
import { WaitlistProvider } from "./pages/waitlist/context/WaitlistContext";
import { FeedbackProvider } from "./pages/feedback/context/FeedbackContext";
import { ContactSubmissionsProvider } from "./pages/contactSubmissions/context/ContactSubmissionsContext";
import { AuthRequestProvider } from "./pages/authRequests/context/RequestAuthContext";
import { CandidSyncProvider } from "./pages/candidSync/context/candid-context";
import { GOOGLE_OAUTH_CLIENT_ID } from "./env";

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <AppProvider>
        <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
          <AdminUsersProvider>
            <ClientReferralProvider>
              <WaitlistProvider>
                <FeedbackProvider>
                  <ContactSubmissionsProvider>
                    <CandidSyncProvider>
                      <AuthRequestProvider>
                        <div className="font-outfit min-h-screen flex flex-col">
                          <ImageCropProvider>
                            <Routes />
                          </ImageCropProvider>
                        </div>
                      </AuthRequestProvider>
                    </CandidSyncProvider>
                  </ContactSubmissionsProvider>
                </FeedbackProvider>
              </WaitlistProvider>
            </ClientReferralProvider>
          </AdminUsersProvider>
        </GoogleOAuthProvider>
      </AppProvider>
    </QueryClientProvider>
  );
}

export default App;
